import React, { Component } from 'react';
import './Title.css';
import Row from 'react-bootstrap/lib/Row';

class Title extends Component {
  constructor(props) {
    super(props);
    this.state = {title:null};
  }
  render() {
    return (
      <div>
        <Row id={this.props.title}>
          <p className={"title " + this.props.color}>{this.props.title}</p>
        </Row>
      </div>
    );
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/objs/Title.js